interface RectDimensions {
    width: number,
    height: number
}

/**
 * Get the scale needed to fit a rect inside another rect
 * @param child inner rectangle
 * @param parent outer rectangle
 */
export function getScale(child: RectDimensions, parent: RectDimensions): number {
    return Math.min(
        parent.width / child.width,
        parent.height / child.height
    );
}

/**
 * Get the maxWidth value that will fit all images into the given parent rect
 * @param images
 */
export function getMaxWidth(images:Array<RectDimensions | false>, parent:RectDimensions): number {
    let scale = 0;
    let ret = 0;

    images.forEach((image:RectDimensions | false)=>{
        if (!image){
            return;
        }
        const imageScale = getScale(image, parent)

        if (!scale || imageScale < scale){
            scale = imageScale;
            ret = scale * image.width;
        }
    });

    return ret;
}